import { Team_NAMES } from "../types/teams";

export const TeamLogos = {
  [Team_NAMES.Dragons]:
    "https://www.nrl.com/Client/dist/logos/dragons-badge.svg?bust=202110292",
  [Team_NAMES.Titans]:
    "https://www.nrl.com/Client/dist/logos/titans-badge.svg?bust=202110292",
  [Team_NAMES.Roosters]:
    "https://www.nrl.com/Client/dist/logos/roosters-badge.svg?bust=202110292",
  [Team_NAMES.Broncos]:
    "https://www.nrl.com/Client/dist/logos/broncos-badge-light.svg?bust=202110292",
  [Team_NAMES.Knights]:
    "https://www.nrl.com/Client/dist/logos/knights-badge-light.svg?bust=202110292",
  [Team_NAMES.Eels]:
    "https://www.nrl.com/Client/dist/logos/eels-badge.svg?bust=202110292",
  [Team_NAMES.Panthers]:
    "https://www.nrl.com/Client/dist/logos/panthers-badge-light.svg?bust=202110292",
  [Team_NAMES["Sea Eagles"]]:
    "https://www.nrl.com/Client/dist/logos/sea-eagles-badge.svg?bust=202110292",
  [Team_NAMES.Raiders]:
    "https://www.nrl.com/Client/dist/logos/raiders-badge-light.svg?bust=202110292",
  [Team_NAMES.Sharks]:
    "https://www.nrl.com/Client/dist/logos/sharks-badge-light.svg?bust=202110292",
  [Team_NAMES.Rabbitohs]:
    "https://www.nrl.com/Client/dist/logos/rabbitohs-badge.svg?bust=202110292",
  [Team_NAMES.Warriors]:
    "https://www.nrl.com/Client/dist/logos/warriors-badge-light.svg?bust=202110292",
  [Team_NAMES.Tigers]:
    "https://www.nrl.com/.theme/wests-tigers/badge-basic24.svg?bust=202403120144",
  [Team_NAMES["Wests Tigers"]]:
    "https://www.nrl.com/.theme/wests-tigers/badge-basic24.svg?bust=202403120144",
  [Team_NAMES.Storm]:
    "https://www.melbournestorm.com.au/client/dist/logos/storm-badge-light.svg?bust=202202171",
  [Team_NAMES.Cowboys]:
    "https://www.nrl.com/Client/dist/logos/cowboys-badge-light.svg?bust=202110292",
  [Team_NAMES.Bulldogs]:
    "https://www.nrl.com/Client/dist/logos/bulldogs-badge.svg?bust=202110292",
  [Team_NAMES.Dolphins]:
    "https://www.dolphinsnrl.com.au/.theme/dolphins/badge-light.svg?bust=202302142313",
  undefined: "",
};

export const TeamsColorsList = {
  [Team_NAMES.Broncos]: ["#6c1d45", "#521633"],
  [Team_NAMES.Raiders]: ["#94c949", "#679c40"],

  [Team_NAMES.Bulldogs]: ["#00468b", "#00306f"],
  [Team_NAMES.Sharks]: ["#1f7eb2", "#15679f"],
  [Team_NAMES.Titans]: ["#047db0", "#084970"],
  [Team_NAMES["Sea Eagles"]]: ["#660238", "#500128"],
  //   "Sea Eagles": ["#660238", "#500128"],
  [Team_NAMES.Storm]: ["#592b8c", "#4f1782"],
  [Team_NAMES.Knights]: ["#003b73", "#002b5d"],
  [Team_NAMES.Cowboys]: ["#0c2340", "#0c192f"],
  [Team_NAMES.Eels]: ["#002d72", "#001b46"],
  [Team_NAMES.Panthers]: ["#2c2f30", "#1f2122"],
  [Team_NAMES.Rabbitohs]: ["#003b19", "#002b11"],
  [Team_NAMES.Dragons]: ["#cd232c", "#a6121c"],
  [Team_NAMES.Roosters]: ["#0b2d5b", "#072046"],
  [Team_NAMES.Warriors]: ["#151f6d", "#0e1557"],
  [Team_NAMES.Tigers]: ["#262626", "#161616"],
  [Team_NAMES["Wests Tigers"]]: ["#262626", "#161616"],
  [Team_NAMES.Dolphins]: ["#e0121a", "#bd0f16"],
  "": ["", ""],
};

export const TeamsBGColors = {
  Broncos: "transparent",
  Raiders: "white",
  Bulldogs: "transparent",
  Sharks: "transparent",
  Titans: "transparent",
  Eagles: "white",
  "Sea Eagles": "transparent",
  Storm: "transparent",
  Knights: "transparent",
  Cowboys: "transparent",
  Eels: "white",
  Panthers: "white",
  Rabbitohs: "white",
  Dragons: "white",
  Roosters: "white",
  Warriors: "transparent",
  Tigers: "white",
  "Wests Tigers": "transparent",
  Dolphins: "transparent",
};
